/**
 * redirectToBlogArticlePage: redirect to blog article page based on slug of the article
 */
export const redirectToBlogArticlePage = function (slug) {
  window.open(`learn/${slug}/`, '_self');
}

/**
 * redirectToSearchCommunityResults: redirect to Search Community Result Page based on 
 * the search endpoint result
 */
export const redirectToSearchCommunityResults = function (searchText) {
  window.open(`Search?SearchText=${searchText}&ToPage=communities`, '_blank');
}

/**
 * redirectToSearchHomesResults: redirect to Search Homes Result Page based on search endpoint result
 */
export const redirectToSearchHomesResults = function (searchText) {
  window.open(`Search?SearchText=${searchText}&ToPage=homes`, '_blank');
}



